import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatusType, TwilioRegistrationDueViewModel } from 'api-clients/voice-and-text-api-client';

@Component({
  selector: 'ez-twilio-registration-modal',
  templateUrl: './twilio-registration-modal.component.html',
  styleUrls: ['./twilio-registration-modal.component.scss'],
  standalone: false,
})
export class TwilioRegistrationModalComponent implements OnInit {
  showDueDays = false;
  showDeclinedStatus = false;
  readonly matDialogData = inject<TwilioRegistrationDueViewModel>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    const status = StatusType[this.matDialogData.status] as unknown as StatusType;
    this.showDueDays = status === StatusType.Unknown || status === StatusType.Draft;
    this.showDeclinedStatus = status === StatusType.BrandStatusFailed;
  }
}
